export default class ErrorPage {
  constructor() {
    this.button = document.querySelector('.js-404-btn');

    this.init();
  }

  getButton() {
    return this.button;
  }

  handleButtonClick() {
    const btn = this.getButton();
    const target = document.querySelector('.js-404-scroll-target');

    if (!target) {
      return;
    }
    const targetTop = target.getBoundingClientRect().top;

    if (!!btn) {
      btn.addEventListener('click', (event) => {
        event.preventDefault();

        window.scrollTo({
          top: targetTop,
          behavior: 'smooth'
        })

        target.classList['add']('is-shaking');
        setTimeout(() => {
          target.classList['remove']('is-shaking');
        }, 1000);
      })
    }
  }

  init() {
    this.handleButtonClick();
  }
}
